// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2jO6J","row":"row___27qRi","title":"title___2AiLu","list":"list___dUwbB","split":"split___2XHIV"};